import createReducer from '../../utils/createReducer';
import actions from './actions';

const actionHandlers = {};

export const initialState = {
    boardId: null,
    endDate: null,
    images: [],
    isOpen: false,
    listingId: null,
    startDate: null,
    timezone: new Date().toTimeString()
};

actionHandlers[actions.MODAL_OPEN] = (state, {payload}) => {
    const isOpen = true;
    const {boardId, listingId, startDate, endDate, ...rest} = payload;
    return {
        ...state,
        boardId,
        endDate,
        isOpen,
        listingId,
        startDate,
        ...rest
    };
};

actionHandlers[actions.MODAL_CLOSE] = () => initialState;

export default createReducer(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/universal/tripboard/comments/reducer.js